module.exports = (urls, options) => {
  let single = false
  if (typeof urls === 'string') {
    urls = [urls]
    single = true
  }

  options = Object.assign({}, {
    trim_all: true,
    add_default_protocol: 'http://',
    lower_case_host: true,
    trim_end_slash: true,
  }, options)

  urls = urls.map(url => {
    try {
      // Cleanup beginning and ending spaces
      if (options.trim_all) url = url.trim()

      // If the string is empty
      if (url === '') return ''

      // Add protocol if not exists
      if (options.add_default_protocol) {
        url = (url.indexOf('://') === -1) ? options.add_default_protocol + url : url
      }

      // Parse url for more advanced manipulations
      const parsed = new URL(url)

      // Lower case the host of the url
      if (options.lower_case_host) parsed.host = parsed.host.toLowerCase()

      // Rebuild url
      url = parsed.toString()

      // Remove the ending slash
      if (options.trim_end_slash) url = url.replace(/\/$/, '')

      return url
    } catch (e) {
      return ''
    }
  })

  if (single) return urls[0]
  else return urls
}